/**
 *
 *
 */

/* 주문 유형 */
export const PAYMENT_METHOD_CONSTANT = {
  NAVER_PAY: {
    title: 'N페이',
    // color: '#87d068',
    color: 'green',
  },
  KAKAO_PAY: {
    title: '카카오페이',
    // color: '#fffe304',
    color: 'yellow',
  },
  CARD: {
    title: '신용카드',
    // color: '#f50',
    color: 'blue',
  },
  CASH: {
    title: '현금',
    color: 'default',
  },
  JM_PAY: {
    title: 'JM Pay',
    color: '#900020',
  },
  TRANSFER: {
    title: '계좌이체',
    color: 'purple',
  },
  VIRTUAL_ACCOUNT: {
    title: '가상계좌',
    color: 'purple',
  },
};

/* 주문의 결제상태 */
export const PAYMENT_STATUS_CONSTANT = {
  PENDING: {
    title: '결제대기',
    color: 'purple',
  },
  COMPLETED: {
    title: '결제완료',
    color: 'green',
  },
  PARTIALLY_REFUNDED: {
    title: '환불',
    color: 'red',
  },
  REFUNDED: {
    title: '전체환불',
    color: 'red',
  },
};

/* 상품유형 */
export const PRODUCT_TYPE = {
  DELIVERY: {
    title: '배송상품',
    color: 'purple',
  },
  RENTAL: {
    title: '대여상품',
    color: 'orange',
  },
  SUBSCRIPTION: {
    title: '구독상품',
    color: 'blue',
  },
  STORE_PICKUP: {
    title: '픽업상품',
    color: 'yellow',
  },
  AMOUNT: {
    title: '금액권',
    color: 'green',
  },
};

/* 상품 포장방식 */
export const PACKAGING_METHOD = {
  REFRIGERATION: { title: '냉장' },
  FREEZING: { title: '냉동' },
  GENERAL: { title: '일반' },
};

/* 상품 판매 상태 */
export const PRODUCT_STATUS = {
  SOLDOUT: { title: '품절', value: 'SOLDOUT', color: 'purple' }, //
  NORMAL: { title: '정상', value: 'NORMAL', color: 'green' }, //
  END: { title: '상품종료', value: 'END', color: 'magenta' }, // --> 삭제된
  STOP: { title: '중지', value: 'STOP', color: 'red' }, //
  WAIT: { title: '대기', value: 'WAIT', color: 'default' }, //
};

/* 상품 등록 승인여부 */
export const APPLICATION_STATUS = {
  APPLY: { title: '신청', color: 'blue' },
  REJECT: { title: '반려', color: 'red' },
  APPROVE: { title: '승인', color: 'green' },
  WAIT: { title: '대기', color: 'default' },
};

/* 과세유형 */
export const TAX_TYPE = {
  TAXABLE: '과세', //
  EXEMPT: '면세', //
  ZERO_RATED: '영세', //
};

/* 상품유형 =>  */
export const DELIVERY_TYPE = {
  DELIVERY: {
    value: 'DELIVERY',
    title: '택배배송', // 일반상품
  },
  SUBSCRIPTION: {
    value: 'SUBSCRIPTION',
    title: '정기배송',
  },
  STORE_PICKUP: {
    value: 'STORE_PICKUP',
    title: '매장픽업',
  },
  RENDER: {
    value: 'RENDER',
    title: '렌탈',
  },
  AMOUNT: {
    value: 'AMOUNT',
    title: '금액권',
  },
};

/* 배송상태 */
export const DELIVERY_STATUS = {
  PENDING: {
    value: 'PENDING',
    title: '배송전(상품준비)',
    color: 'default',
  },
  PREPARING: {
    value: 'PREPARING',
    title: '배송 준비중',
    color: 'default',
  },
  ON_HOLD: {
    value: 'ON_HOLD',
    title: '배송 보류중',
    color: 'default',
  },
  SHIPPING: {
    value: 'SHIPPING',
    title: '배송중',
    color: 'blue',
  },
  DELIVERED: {
    value: 'DELIVERED',
    title: '배송완료',
    color: 'green',
  },
  EXCHANGE_REQUESTED: {
    value: 'EXCHANGE_REQUESTED',
    title: '교환 신청',
    color: 'default',
  },
  EXCHANGE_COMPLETED: {
    value: 'EXCHANGE_COMPLETED',
    title: '교환 완료',
    color: 'default',
  },
  RETURN_REQUESTED: {
    value: 'RETURN_REQUESTED',
    title: '반품 신청',
    color: 'default',
  },
  RETURN_COMPLETED: {
    value: 'RETURN_COMPLETED',
    title: '반품 완료',
    color: 'default',
  },
};

export const RENTAL_TYPE_CONSTANT = {
  ADD_TOTAL: {
    title: '총 금액에 추가',
    color: 'default',
  },
  MINUS_TOTAL: {
    title: '총 금액에 할인',
    color: 'default',
  },
  ADD_MONTH: {
    title: '월 금액에 추가',
    color: 'default',
  },
  MINUS_MONTH: {
    title: '월 금액에 할인',
    color: 'default',
  },
};
